/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
var n = /* @__PURE__ */ ((e) => (e[e.UploadFailed = 0] = "UploadFailed", e[e.Initial = 1] = "Initial", e[e.Selected = 2] = "Selected", e[e.Uploading = 3] = "Uploading", e[e.Uploaded = 4] = "Uploaded", e[e.RemoveFailed = 5] = "RemoveFailed", e[e.Removing = 6] = "Removing", e))(n || {});
export {
  n as UploadFileStatus
};
